import { ChangeDetectionStrategy, Component, OnInit, computed } from '@angular/core';
import { LicenseType } from 'account-hybrid/core/authentication';
import { LicenseService } from 'account-hybrid/core/license.service';
import { PlatformStateService } from 'account-hybrid/core/platform-state.service';

/**
 * Native-Angular port of the AngularJS account-v2 `ftPeople` shell component
 * (account-v2/.../people/people.component.ts + people.html).
 *
 * Why top-level: the AngularJS shell can't host an Angular DirectoryComponent
 * that itself needs to host the AngularJS `ftPeopleDetails` modal — the hybrid
 * won't fill an Angular <ui-view> nested inside an AngularJS ui-view. Making
 * the People sub-tree Angular-rooted (matching the Stories pattern) is what
 * lets the modal render again. AngularJS leaf states (people.feedback,
 * *.details) are kept by registering them via PeopleModule's forChild with
 * their string component name — same pattern as `stories.details`.
 *
 * Markup mirrors account-v2/people.html so the /people route stays
 * pixel/css-parity against the frozen baseline.
 */
@Component({
    selector: 'ft-people',
    templateUrl: './people.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleComponent implements OnInit {
  hasLicense = false;
  // Platform state can land after the first render; reading its signal here re-renders this view (FTK-7973).
  readonly hasAudience = computed(() => !!this.platformStateService.state?.hasAudience);

  constructor(
    private readonly licenseService: LicenseService,
    private readonly platformStateService: PlatformStateService,
  ) {}

  ngOnInit(): void {
    this.hasLicense = this.licenseService.checkCurrentSpaceLicense(LicenseType.Advocacy);
  }
}
